
        ;
        'use strict';

var $ = window.$;
$('.bottom-ad').first().css('margin-top', '100px');
$('.split').first().css('margin-top', '100px');
if ($('.bottom-ad').length == 0) {
    $('.split').css('display', 'block');
}
var flag = $('.bottom-ad a').attr('data-flag');
if (flag == '1') $('.bottom-ad a').addClass('ad');;
    


// WEBPACK FOOTER //
// ./src/module/home-list/bottom-ad/index.js